module.exports = __webpack_public_path__ + "static/envyforge-marquee-light-ae57dcee6dceccde8a0f4a35cc0270e6.png";